// extracted by mini-css-extract-plugin
module.exports = {"popus":"popus--3LBdC","soft_text":"soft_text--3vuHU"};